RivalIQ.module('postTags.mixins', function (mixins, App, Backbone, Marionette, $, _) {

    'use strict';

    mixins.PostTagsEventingMixin = {
        afterConstruction: function () {
            const me = this;
            Marionette.bindEntityEvents(me, App.postTags.data.PostTags, me.postTagManagerEvents);
        }
    };

    mixins.PostSelectionMixin = {

        afterConstruction: function () {
            const me = this;
            me._selectedPosts = {};
        },

        resetSelectedPosts: function () {
            const me = this;
            me._selectedPosts = {};
            me.trigger('selectedPostsReset');
        },

        setPostSelection: function (postId, channel, postNativeId, newValue) {
            const me = this;

            me._setPostSelection(postId, channel, postNativeId, newValue);
            me.trigger('selectedPostsChanged');
        },

        setPostsSelection: function (posts, newValue) {
            const me = this;

            _.each(posts, function (post) {
                me._setPostSelection(post.postId, post.channel, post.postNativeId, newValue);
            });

            me.trigger('selectedPostsChanged');
        },

        _setPostSelection: function (postId, channel, postNativeId, newValue) {
            const me = this;

            newValue = Boolean(newValue);
            const postKey = App.postTags.utils.makePostKey(channel, postNativeId);
            if (!newValue) {
                delete me._selectedPosts[postKey];
            } else {
                me._selectedPosts[postKey] = {
                    postId: postId,
                    postKey: postKey,
                    channel: channel,
                    postNativeId: postNativeId
                };
            }
        },

        isSelected: function (postId) {
            const me = this;
            return Boolean(_.find(me._selectedPosts, function (v) {
                return v.postId === postId;
            }));
        },

        getSelectedPosts: function () {
            const me = this;

            return _.values(me._selectedPosts);
        },

        setLoadedPosts: function (posts) {
            const me = this;
            me.loadedPosts = posts;
            me.trigger('loadedPostsChanged');
        },

        getLoadedPosts: function () {
            const me = this;
            return me.loadedPosts;
        },

        setQueryModeEnabled: function (queryModeEnabled) {
            const me = this;

            me.queryModeEnabled = Boolean(me.queryModeEnabled);
            queryModeEnabled = Boolean(queryModeEnabled);
            if (me.queryModeEnabled !== queryModeEnabled) {
                me.queryModeEnabled = queryModeEnabled;
                me.trigger('queryModeEnabledChanged');
            }
        },

        getQueryModeEnabled: function () {
            const me = this;
            return Boolean(me.queryModeEnabled);
        },

        setTotalNumPosts: function (totalNumPosts) {
            const me = this;
            me.totalNumPosts = totalNumPosts;
        },

        getTotalNumPosts: function () {
            const me = this;
            return me.totalNumPosts;
        },

        setPostTagCounts: function (postTagCounts) {
            const me = this;

            me.postTagCounts = _(postTagCounts)
                .keyBy(_.head)
                .mapValues(_.last)
                .value();
        },

        getPostTagCounts: function () {
            const me = this;
            return me.postTagCounts;
        },

        getPostsQuery: function () {
            return {};
        }
    };
});
